import { Select } from '@mantine/core';

interface Props {
  currentSorting: string
  onSortingChange: (sorting: string) => void
  disabled: boolean
  labelToDbFieldMap: Map<string, string>
}

const SortingSelector: React.FC<Props> = (props: Props) => {
  const { currentSorting, onSortingChange, disabled, labelToDbFieldMap } = props;
  const selectData = [...labelToDbFieldMap.keys()].map(key => ({ value: key, label: key }));
  return <>
    <Select
      w={255}
      allowDeselect={false}
      data={selectData}
      value={currentSorting}
      onChange={(value) => { onSortingChange(value ?? ''); }}
      disabled={disabled}
    />
  </>;
};

export default SortingSelector;
